import React from 'react'
import PropTypes from 'prop-types'

const NameOrTypeSearch = ({ onSearch }) => (
  <div className='br-experience-filter'>
    <span>
      <i className='fa fa-search' />
    </span>
    <input
      type='search'
      className='form-control'
      placeholder='Search by name or type'
      onChange={onSearch}
    />
  </div>
)

NameOrTypeSearch.displayName = 'NameOrTypeSearchComponent'

NameOrTypeSearch.propTypes = {
  onSearch: PropTypes.func
}

export default NameOrTypeSearch



// WEBPACK FOOTER //
// ./src/pages/my-experiences/name-or-type-search/index.js